import DraggalbeQuestion from './DraggableQuestion';

export default DraggalbeQuestion;
